import type { IconProps } from '../types/IconProps.ts';
export const WandSparkles: IconProps = {
    name: 'WandSparkles',
    children: [
        `<rect width="4" height="25.5" x="19.53" y="1.5" rx="1" transform="rotate(45 19.53 1.5)" />`,
        `<path d="m13 9 2 2M19 14v4M5 6v4M17 16h4M3 8h4M11 2v2M10 3h2" />`,
    ]
};